import React from 'react';

import FormLoader from '../../components/ProgressLoaders/FormLoader/FormLoader';

import classes from './CardWrapper.module.css';

const cardWrapper = (props) => (
	<div className={[classes.CardWrapper, props.noShadow ? classes.NoShadow : null].join(' ')}>
		{props.isLoading ? <FormLoader /> : null}
		{props.children}
	</div>
)

export default cardWrapper;